import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { GET_AGENTS, GET_PROJECT_AGENT, getAgents, getProjectAgent } from '../redux/id8/id8Actions';
import { AGENT_TYPES } from '../constants';

const useId8AgentOptions = () => {
  const { t } = useTranslation('id8');
  const dispatch = useDispatch();

  const agentsList = useSelector((state) => state.id8.agentsList);
  const projectAgent = useSelector((state) => state.id8.projectAgent);
  const editProject = useSelector((state) => state.projects.editProject);

  const loadingActions = useSelector((state) => state.global.loadingActions);

  const isLoading = useMemo(() => {
    return loadingActions[GET_AGENTS] || loadingActions[GET_PROJECT_AGENT];
  }, [loadingActions]);

  const agentsOptions = useMemo(
    () => [
      ...agentsList.map((agent) => ({
        label: agent.name,
        value: agent.id,
        type: agent.type,
        ...agent,
      })),
    ],
    [agentsList],
  );

  const CUSTOM_AGENT_OPTION = {
    label: t('custom'),
    value: projectAgent && projectAgent.type === AGENT_TYPES.CUSTOM ? projectAgent.id : AGENT_TYPES.CUSTOM,
    type: AGENT_TYPES.CUSTOM,
    instructions: projectAgent && projectAgent.type === AGENT_TYPES.CUSTOM ? projectAgent.instructions : '',
  };

  const NONE_AGENT_OPTION = {
    label: '',
    value: '',
    instructions: '',
  };

  useEffect(() => {
    dispatch(getAgents());
  }, [dispatch]);

  useEffect(() => {
    if (editProject?.agentId) {
      dispatch(getProjectAgent(editProject.agentId));
    }
  }, [dispatch, editProject?.agentId]);

  return {
    isLoading,
    agentsOptions,
    CUSTOM_AGENT_OPTION,
    NONE_AGENT_OPTION,
  };
};

export default useId8AgentOptions;
